import { useCustomerDetailContext } from '@/pages/admin/AdminCustomerDetail';
import { CustomerUsersPanel } from './CustomerUsersPanel';

export default function UsersTab() {
  const { customer } = useCustomerDetailContext();
  return <CustomerUsersPanel customerId={customer.id} customerName={customer.name} />;
}
